import { render } from "./AboutHome.vue?vue&type=template&id=f9b1472a"
import script from "./AboutHome.vue?vue&type=script&lang=js"
export * from "./AboutHome.vue?vue&type=script&lang=js"
script.render = render

export default script